import { UserID, UserNanoID } from '../users/usersTypes';

export class UserCompetencyCache {
  static userCompetencies(userId: UserNanoID | UserID) {
    return `user-${userId}-competencies`;
  }
}
